import Translation from "components/Translation"
import { useRouter } from "next/router"

export function DisplayTitle() {
    const router = useRouter()
    let title = router.pathname.split('/').pop() || ''
    
    return (
        <h1 className="text-xl font-medium text-custom-dark-cyan-blue w-4/12">
            <Translation content_key={title} render_as='span' className='capitalize'/>
        </h1>
    )
}